import React from 'react';
import { Stack } from '@hub/stack';
import { Link } from '@hub/link';
import { jsx as _jsx } from "react/jsx-runtime";

const TileLink = ({
  url,
  isLastChild = false,
  children,
  as
}) => /*#__PURE__*/_jsx(Link, {
  href: url,
  sx: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: ['smoke', 'smoke', 'transparent', 'transparent'],
    borderRightWidth: isLastChild ? 'none' : ['0px', '0px', '1px '],
    borderRightStyle: isLastChild ? 'none' : 'solid',
    borderRightColor: isLastChild ? 'transparent' : ['transparent', 'transparent', 'ghost', 'ghost'],
    _last: {
      borderRightWidth: '0'
    }
  },
  children: /*#__PURE__*/_jsx(Stack, {
    align: "center",
    justify: "center",
    sx: {
      paddingX: 'spacing-sm',
      paddingY: 'spacing-md',
      minWidth: '132px'
    },
    as: as,
    children: children
  })
});

export default TileLink;